/**
 * Subtask Types
 */

export enum SubtaskStatus {
  TODO = 'todo',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
}

export interface Subtask {
  id: string;
  taskId: string;
  subtaskNumber: number | null;
  key: string | null; // e.g. "ST-2"
  title: string;
  status: SubtaskStatus;
  assigneeId: number | null;
  position: number;
  createdAt: string;
  updatedAt: string;

  // Relation
  assignee?: {
    id: number;
    fullName: string;
    userName: string;
    email: string;
  } | null;
}

export interface CreateSubtaskDto {
  title: string;
  status?: SubtaskStatus;
  assigneeId?: number;
  position?: number;
}

export interface UpdateSubtaskDto {
  title?: string;
  status?: SubtaskStatus;
  assigneeId?: number | null;
  position?: number;
}
